export const LINK_PROCESSING = {
  LINK_PATTERN: /<a /g,
  LINK_REPLACEMENT: '<a class="text-inverse hover:underline" '
} as const;
